import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import {
  cleanMessageBusiness,
  getBusiness,
  loadEmptyBusiness,
  saveBusiness,
} from "../../store/actions";
import { useEffect } from "react";
import useQueryParams from "../../customHooks/useQueryParams";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import { setValuesHookForm } from "../../helpers/load_object_hook_form";
import { fieldsMessage } from "../../helpers/utils/fieldsMessage";
import "../../assets/scss/_commomAdminPages.scss";
import { useNavigate } from "react-router-dom";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";

const BusinessDetail = ({
  saveBusinessRequest,
  getBusinessRequest,
  cleanMessageBusiness,
  isBusinessSave,
  business,
  loadEmptyBusiness,
  loadingBusiness,
  messageBusiness,
  errorLoadingBusiness
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      active: true,
    }
  });

  const alertModal = withReactContent(Swal);

  const navigate = useNavigate();
  const query = useQueryParams();
  const id = query.get("id");

  const handleBack = () => {
    loadEmptyBusiness();
    navigate("/businesses");
  };
  
  const handleSave = (values) => {
    if (id === null) {
      saveBusinessRequest({
        body: { name: values.name, active: values.active },
        type: "POST",
      });
    } else {
      saveBusinessRequest({
        body: { name: values.name, active: values.active, id: id },
        type: "PUT",
      });
    }
  };

  const actions = useContextActions({
    context: "business",
    screen: "detail",
  })
  const editableWithSave = actions.some(e => e === "save");

  useEffect(() => {
    if (id !== null) {
      getBusinessRequest({ businessId: id });
    }

    return () => {
      cleanMessageBusiness();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isBusinessSave !== null) {
      alertModal
        .fire({
          title:
            isBusinessSave === true
              ? `Business ${id === null ? "created" : "updated"} successfully`
              : `${messageBusiness !== null ? messageBusiness : "Something wrong, try again later."}`,
          icon: isBusinessSave === true ? "success" : "error",
          showConfirmButton: false,
          timer: isBusinessSave === true ? 2000 : undefined,
          showCloseButton: !isBusinessSave,
				  timerProgressBar: isBusinessSave === true ? true : false,
        })
        .then((result) => {
          cleanMessageBusiness();
          if(isBusinessSave)
            navigate("/businesses")
        });
    }

    // eslint-disable-next-line
  }, [isBusinessSave]);

  useEffect(() => {
    if (errorLoadingBusiness !== null) {
      alertModal
        .fire({
          title: "Something wrong, try again later.",
          icon: "error",
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: false,
          //timer: 2000,
          //timerProgressBar: true,
        }).then((result) => {
          if (errorLoadingBusiness) {
            if (result.dismiss) {
              cleanMessageBusiness();
              loadEmptyBusiness();
              navigate("/businesses");
            }
          }
          if (result.dismiss) {
            cleanMessageBusiness();
            loadEmptyBusiness();
          }
        })
    }

    // eslint-disable-next-line
  }, [errorLoadingBusiness]);

  useEffect(() => {
    if (!business) return;

    setValuesHookForm(business, setValue);
    setValue("active", business.active ?? true);

    // eslint-disable-next-line
  }, [business]);

  return (
    <div className="page-content">
      <Helmet>
        <title>Business</title>
      </Helmet>
      <div></div>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <div>
                  <Row className="my-2">
                    {loadingBusiness ? (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ height: "400px", width: "100%" }}
                      >
                        <Spinner
                          color="primary"
                          style={{ height: "5rem", width: "5rem" }}
                        />
                      </div>
                    ) : (
                      <>
                        <form onSubmit={handleSubmit(handleSave)}>
                          <div className="d-flex justify-content-between my-2">
                            <h2>{id === null ? "CREATE" : "EDIT"} BUSINESS</h2>
                            <div className="d-flex gap-2 mb-4">
                              <ButtonCustom
                                type="cancel"
                                onClick={() => handleBack()}
                              />
                              <ActionButtons 
                                actions={actions}
                                handlers={{
                                  save: handleSubmit(handleSave),
                                }}
                              />
                            </div>
                          </div>
                          <Row>
                            <Col md="4">
                              <FormGroup className="mb-3">
                                <Label
                                  htmlFor="name"
                                  className="label-detail-form"
                                >
                                  Name
                                </Label>
                                <input
                                  className="form-control"
                                  id="name"
                                  type="text"
                                  disabled={!editableWithSave}
																	style={!editableWithSave ? {color: "#00000060"} : {}}
                                  {...register("name", {
                                    required:
                                      fieldsMessage.required("Business name"),
                                    validate: (value) =>
                                      value.trim() !== "" ||
                                      fieldsMessage.required("Business name"),
                                    maxLength: {
                                      value: 100,
                                      message: fieldsMessage.maxLength(
                                        "Business name",
                                        100
                                      ),
                                    },
                                  })}
                                />
                                <p className="error-form">
                                  {errors.name?.message}
                                </p>
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  htmlFor="createUser"
                                  className="label-detail-form"
                                >
                                  Created By
                                </Label>
                                <input
                                  className="form-control"
                                  id="createUser"
                                  {...register("createUser")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  id="createDate"
                                  className="label-detail-form"
                                >
                                  Creation Date
                                </Label>
                                <input
                                  className="form-control"
                                  name="createDate"
                                  {...register("createDate")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  id="updateUser"
                                  className="label-detail-form"
                                >
                                  Updated By
                                </Label>
                                <input
                                  className="form-control"
                                  name="updateUser"
                                  {...register("updateUser")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup className="mb-3">
                                <Label
                                  id="updateDate"
                                  className="label-detail-form"
                                >
                                  Update Date
                                </Label>
                                <input
                                  className="form-control"
                                  name="updateDate"
                                  {...register("updateDate")}
                                  disabled
                                  style={{ color: '#00000060'}}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row className="my-2 mb-4">
                            <Col>
                              <FormGroup>
                                <label htmlFor="active" className="label-check">
                                  <input
                                    id="active"
                                    type="checkbox"
                                    className="form-check-input"
                                    {...register("active")}
                                    disabled={!editableWithSave}
                                  />
                                  Active Status
                                </label>
                              </FormGroup>
                            </Col>
                          </Row>
                        </form>
                      </>
                    )}
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = ({
  BusinessReducer: {
    loadingBusiness,
    business,
    messageBusiness,
    isBusinessSave,
    errorLoadingBusiness,
  },
}) => ({
  loadingBusiness,
  business,
  messageBusiness,
  isBusinessSave,
  errorLoadingBusiness,
});

const mapDispatchToProps = {
  saveBusinessRequest: saveBusiness.request,
  getBusinessRequest: getBusiness.request,
  loadEmptyBusiness,
  cleanMessageBusiness,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessDetail);
